import {BaseResultDTO} from "./baseResultDTO.interface";
import {AddressDTO} from "../addressDTO.interface";

export interface AddressSearchResultDTO extends BaseResultDTO
{
  address?: AddressDTO;
  addresses?: AddressDTO[];
}
